<template>
  <div class="card">
    <div>
      <v-chart
        :option="chartOptions"
        style="width: 250px; height: 183px;"
      ></v-chart>
    </div>
    <div style="text-align: center;">
      <div
        :style="{
          display: 'inline-block',
          fontWeight: '600',
          marginTop: '-15px',
          color: titleColor
        }"
      >
        Realizado:
      </div>
      <div
        :style="{
          marginLeft: '4px',
          display: 'inline-block',
          fontWeight: '600',
          color: valueColor
        }"
      >
        {{ formattedValue }}
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  props: {
    title: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    isHorimeter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleColor() {
      return this.$store.state.darkmode ? "#FFFFFF" : "#000000";
    },
    successColor() {
      return this.isHorimeter ? "#ec5353" : "#34A019";
    },
    dangerColor() {
      return this.isHorimeter ? "#34A019" : "#ec5353";
    },
    valueColor() {
      let done = this.model.value;
      let goal = this.model.goal;
      return done <= goal ? this.dangerColor : this.successColor;
    },
    formattedValue() {
      return this.model.value.toString().replace(".", ",");
    },
    formattedGoal() {
      return this.model.goal.toString().replace(".", ",");
    },
    chartOptions() {
      let done = this.model.value;
      let maximal = this.model.max;
      const first_part_proportion = done / maximal;
      const second_part_proportion = 2 - first_part_proportion;
      let title_color = "#FFFFFF";
      let white_theme_bar = "#FFFFFF";
      let bar_color =
        done <= this.model.goal ? this.dangerColor : this.successColor;

      if (!this.$store.state.darkmode) {
        title_color = "#000000";
        white_theme_bar = "#b6b8ad";
      }

      return {
        title: {
          text: this.title,
          left: "center",
          top: "5%",
          textStyle: {
            color: title_color,
            fontSize: 15
          }
        },
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "80%"],
            radius: "100%",
            min: this.model.min,
            max: this.model.max,
            splitNumber: 1,
            axisLine: {
              lineStyle: {
                width: 30,
                color: [
                  [first_part_proportion, bar_color],
                  [second_part_proportion, white_theme_bar]
                ]
              }
            },
            pointer: {
              length: "75%",
              width: 2,
              offsetCenter: [0, "-20%"],
              itemStyle: {
                color: "#ffa500"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              distance: 15,
              color: title_color,
              fontSize: 12
            },
            title: {
              show: false
            },
            detail: {
              show: true,
              offsetCenter: [0, "15%"],
              fontSize: 14,
              color: "#ffa500",
              fontWeight: "normal",
              formatter: () => this.formattedGoal
            },
            data: [
              {
                value: this.model.goal
              }
            ]
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  max-width: 100%;
  padding: 15px;
  background-color: #1e1e2f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  margin-bottom: 0;
  transition: transform 0.3s, box-shadow 0.3s;
  overflow: hidden;
  align-items: center;
  border-color: #ffffff;
  border: 1px solid;
}
</style>
